/**
 * Created by tigran on 30.12.24
 **/

import React, { FC, ReactNode, useMemo } from 'react';

type TypeStatusWrapper = {
  children?: ReactNode;
  size: number;
  statusColor?: 'Online' | 'Away' | 'Offline';
  dataTestId?: string;
};

const colorPalette = {
  Online: '#68D85C',
  Away: '#EFB034',
  Offline: 'red',
};

export const StatusWrapper: FC<TypeStatusWrapper> = ({
  children,
  size,
  statusColor,
  dataTestId,
}) => {
  const additionalStyles = useMemo(() => {
    return {
      backgroundColor: statusColor ? colorPalette[statusColor] : 'transparent',
      width: size,
      height: size,
      borderRadius: size / 2,
    };
  }, [statusColor]);
  return (
    <div
      data-test-id={`${dataTestId}-status-wrapper`}
      className="status-wrapper"
    >
      {children}
      {statusColor && (
        <div className="status-circle" style={additionalStyles} />
      )}
    </div>
  );
};
